import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Info } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
import { PHONE, PHONE_TEL } from '../constants/business';
export function SuppressorsNFA() {
  useDocumentMeta('Suppressors & NFA Process | Kjergaard Sports', 'Learn about buying suppressors and NFA items at Kjergaard Sports. We offer in-store Form 4 submission, electronic fingerprints, and guidance.');
  return <div data-id="element-1206">
      <PageHero title="Suppressors & NFA Process" image="https://cdn.magicpatterns.com/uploads/jwChz1kho8pae8NFhrqrQH/accessories-wall.jpg" alt="Accessories and shooting supplies at Kjergaard Sports" data-id="element-1207" />

      <section className="py-20 bg-brand-offwhite" data-id="element-1208">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1209">
          <div className="max-w-3xl mb-16" data-id="element-1210">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1211">
              Navigating the NFA Process
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1212">
              Buying a suppressor or other NFA item doesn't have to be
              intimidating. Kjergaard Sports can help you through the ATF Form 4
              process in-store. We provide the tools and guidance to make your
              purchase as smooth as possible.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1213">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-1214">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-1215">
                What We Can Handle In-Store
              </h3>
              <ul className="space-y-4" data-id="element-1216">
                <li className="flex items-start" data-id="element-1217">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-1218" />
                  <span className="text-brand-charcoal/90" data-id="element-1219">
                    <strong data-id="element-1220">Electronic Fingerprints:</strong> We can take your
                    fingerprints electronically right here in the store.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1221">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-1222" />
                  <span className="text-brand-charcoal/90" data-id="element-1223">
                    <strong data-id="element-1224">Form 4 Submission:</strong> We can submit your ATF
                    Form 4 in-store.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1225">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-1226" />
                  <span className="text-brand-charcoal/90" data-id="element-1227">
                    <strong data-id="element-1228">Same-Day Submission:</strong> If you have all your
                    information ready, we can often submit your paperwork the
                    same day you purchase.
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-1229">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-1230">
                Before You Visit
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-4" data-id="element-1231">
                To make the process as fast as possible, please set up your ATF
                eForms account ahead of time before coming in to buy a
                suppressor.
              </p>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1232">
                Having your eForms username and PIN ready allows us to submit
                your Form 4 electronically without delays.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1233">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-1234">
              <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-1235">
                Individual vs. Trust Filing
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-4" data-id="element-1236">
                <strong data-id="element-1237">Filing as an Individual:</strong> This is normally the
                easiest and fastest walk-in process.
              </p>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1238">
                <strong data-id="element-1239">Filing as a Trust:</strong> This process is more
                time-consuming. If you plan to file using a trust, please call
                ahead to make an appointment.
              </p>
            </div>

            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-1240">
              <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-1241">
                Non-Minnesota Customers
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1242">
                Non-Minnesota residents can still buy suppressors through
                Kjergaard Sports. The item will simply need to be transferred to
                a dealer in your home state where allowed. This is a normal,
                manageable process that we handle regularly.
              </p>
            </div>
          </div>

          <div className="bg-brand-cream border-l-4 border-brand-leather p-6 mb-12" data-id="element-1243">
            <div className="flex items-start" data-id="element-1244">
              <Info className="w-6 h-6 text-brand-leather mr-4 flex-shrink-0 mt-0.5" data-id="element-1245" />
              <p className="text-brand-charcoal/90 text-sm leading-relaxed" data-id="element-1246">
                <strong data-id="element-1247">Compliance Note:</strong> All NFA-related services are
                handled in accordance with applicable federal, state, and local
                laws. Information on this page is general information only and
                is not legal advice. Requirements can vary. Please call the
                store with questions. We do not make guarantees about ATF
                approval times.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-1248">
            <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-1249">
              Call Before You Come In
            </h3>
            <p className="text-brand-charcoal/80 mb-8 max-w-2xl mx-auto" data-id="element-1250">
              We encourage customers to call ahead with NFA questions so we can
              ensure you have everything you need before making the drive.
            </p>
            <a href={PHONE_TEL} className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors" data-id="element-1251">
              Call {PHONE}
            </a>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-1252" />
    </div>;
}